import './modal.css'
import { FiX } from 'react-icons/fi';



export default function Modal({conteudo, close}) {
    return (
        <div className='modal'>
            <div className='container'>

                <main>
                    <h2>{conteudo}</h2>
                </main>

                <button className='close' onClick={ close }>
                    <FiX size={38} />
                    OK
                </button>

            </div>
        </div>
    );
}